import { useState, useEffect } from "react";

export const useAllocationFilters = (onFilterChange) => {
  const [teacherFilter, setTeacherFilter] = useState("");
  const [classFilter, setClassFilter] = useState("");
  const [streamFilter, setStreamFilter] = useState("");
  const [yearFilter, setYearFilter] = useState("");
  const [termFilter, setTermFilter] = useState("");
  const [activeFilter, setActiveFilter] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      const filters = {};
      if (teacherFilter) filters.teacher_id = teacherFilter;
      if (classFilter) filters.class_id = classFilter;
      if (streamFilter) filters.stream_id = streamFilter;
      if (yearFilter) filters.academic_year = yearFilter;
      if (termFilter) filters.term_id = termFilter;
      if (activeFilter !== "") filters.is_active = activeFilter;
      
      onFilterChange(filters);
    }, 300);

    return () => clearTimeout(timer);
  }, [teacherFilter, classFilter, streamFilter, yearFilter, termFilter, activeFilter, onFilterChange]);

  const clearFilters = () => {
    setTeacherFilter("");
    setClassFilter("");
    setStreamFilter("");
    setYearFilter("");
    setTermFilter("");
    setActiveFilter("");
  };

  const hasActiveFilters = () => {
    return teacherFilter || classFilter || streamFilter || yearFilter || termFilter || activeFilter !== "";
  };

  return {
    teacherFilter,
    setTeacherFilter,
    classFilter,
    setClassFilter,
    streamFilter,
    setStreamFilter,
    yearFilter,
    setYearFilter,
    termFilter,
    setTermFilter,
    activeFilter,
    setActiveFilter,
    clearFilters,
    hasActiveFilters,
  };
};
